<div class="demo-list-container" *ngIf="(demoState | async).auditList !== null">
  <!-- Section Header -->
  <div class="demo-header">
    <div class="header-icon">
      <i class="bi bi-play-circle-fill"></i>
    </div>
    <div class="header-content">
      <h3>Demo Reports</h3>
      <p>Explore full-featured sample reports to see what insights you can get</p>
    </div>
  </div>

  <!-- Loading State -->
  <div class="demo-loading" *ngIf="!(profileState | async).loader['auditList']['list']">
    <div class="spinner-small"></div>
  </div>

  <!-- Demo Cards Grid -->
  <div class="demo-grid" [class.loading]="!(profileState | async).loader['auditList']['list']">
    <a class="demo-card" *ngFor="let demo of (demoState | async).auditList" [routerLink]="['/demo', demo.id]">
      <!-- Card Background Pattern -->
      <div class="card-pattern"></div>

      <!-- Demo Badge -->
      <span class="demo-badge" *ngIf="demo.status === 1">
        <i class="bi bi-stars"></i> Demo
      </span>
      <span class="demo-badge disabled" *ngIf="demo.status === 0">
        <i class="bi bi-pause-circle"></i> Disabled
      </span>

      <!-- Profile Info -->
      <div class="demo-profile">
        <div class="demo-avatar">
          <i class="bi bi-person-fill"></i>
        </div>
        <span class="demo-username">&#64;{{demo.credentials.username}}</span>
      </div>

      <!-- Card Footer -->
      <div class="demo-footer">
        <span class="demo-date">
          <i class="bi bi-calendar3"></i>
          {{demo.date_add * 1000 | date:'mediumDate'}}
        </span>
        <span class="view-link">
          View Report
          <i class="bi bi-arrow-right"></i>
        </span>
      </div>
    </a>
  </div>

  <!-- Empty State -->
  <div class="demo-empty" *ngIf="(demoState | async).auditList?.length === 0">
    <i class="bi bi-inbox"></i>
    <p>No demo reports available</p>
  </div>
</div>
